// TODO - Type 'any' needs to be fixed.
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";

import useSchedulerData from "../../../controllers/use-scheduler-data";
import { removeWorker, resetRemoveWorker } from "../../../store/scheduler-slice";
import ShiftStatus from "../shift-details-dialog/ShiftStatus";


interface RemoveWorkerMessageFormProps {
  shiftId?: any;
  worker?: any;
  isDilogueOpen?: boolean;
  handleClose?: any;
}

const RemoveShiftWorkerDialog: React.FC<RemoveWorkerMessageFormProps> = ({
  shiftId,
  worker,
  isDilogueOpen,
  handleClose,
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const {removeWorkerStatus} = useSchedulerData();
  const [isDialogOpen, setIsDialogOpen] = useState(isDilogueOpen);

  const [comment, setComment] = useState(worker.comment ?? "");

  // useEffect(() => {
  // 	setActiveChip(worker.status);
  // }, [worker]);

  // const handleOpen = () => {
  //   setComment(worker.comment ?? "");
  //   setIsDialogOpen(true);
  // };

  useEffect(() => {
		if (removeWorkerStatus === "fulfilled") {
			handleClose();
		}
	}, [removeWorkerStatus, handleClose]);


  const handleSubmit = (worker :any ) => {
    dispatch(
      removeWorker({
        workerId: worker.workerId,
        shiftId: shiftId,
        removeReason: comment,
      })
    );
  };

  const disableSave = () => {
    return comment.length > 250 || comment.length === 0 || removeWorkerStatus === "pending";
  };

  return (
    <>
      {isDialogOpen && (
        <Dialog
          open={isDialogOpen}
          onClose={handleClose()}
          aria-describedby="alert-dialog-slide-description"
          sx={{
            "& .MuiDialog-paper": {
              width: "750px",
              maxWidth: "750px",
            },
          }}
        >
          <DialogTitle
            sx={{
              padding: "45px 45px 24px",
              fontFamily: "Roboto",
              fontWeight: 400,
              fontSize: "24px",
              lineHeight: "32px",
              color: "rgba(28, 27, 31, 1)",
            }}
          >
            {t("scheduler_remove-worker-from-shift")}
          </DialogTitle>
          <DialogContent
            sx={{
              padding: "0px 45px 24px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
              }}
            >
              <Typography
                sx={{
                  fontSize: "14px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  padding: "4px 0px",
                  color: "rgba(73, 69, 79, 1)",
                }}
              >
                {t("scheduler_remove-worker-confirm-message")}
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "12px 0",
                width: "100%",
                maxWidth: 400,
                backgroundColor: "#fff",
              }}
            >
              {/* Worker Name */}
              <Box>
                <Typography
                  sx={{
                    fontfamily: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "rgba(0, 0, 0, 0.6)",
                    lineHeight: "16px",
                    marginBottom: "2px",
                  }}
                >
                  {t("scheduler_worker-name")}
                </Typography>
                <Typography
                  sx={{
                    fontfamily: "Roboto",
                    fontSize: "14px",
                    fontWeight: 400,
                    color: "rgba(0, 0, 0, 0.87)",
                    lineHeight: "20px",
                  }}
                >
                  {worker?.workerName}
                </Typography>
              </Box>

              {/* Shift Status */}
              <Box>
                <Typography
                  sx={{
                    fontfamily: "Roboto",
                    fontSize: "12px",
                    fontWeight: 400,
                    color: "rgba(0, 0, 0, 0.6)",
                    lineHeight: "16px",
                    marginBottom: "2px",
                  }}
                >
                  {t("scheduler_shift-status")}
                </Typography>

                <ShiftStatus label={worker?.status} reason={worker?.reason} />
              </Box>
            </Box>
            <Box
              sx={{
                marginTop: "18px",
              }}
            >
              <TextField
                sx={{
                  "& .MuiInputBase-root": {
                    backgroundColor: "rgba(248, 248, 248, 1)", // your desired background color
                  },
                }}
                id="outlined-multiline-static"
                multiline
                rows={3}
                fullWidth
                defaultValue={worker.comment ?? ""}
                onChange={(e) => setComment(e.target.value)}
                error={comment.length > 250}
                helperText={
                  comment.length > 250
                    ? t("scheduler_comment-max-length")
                    : ""
                }
                variant="filled"
                placeholder={t("scheduler_reason-for-removal")}
              />
              {/* <Typography
                sx={{
                  fontSize: "12px",
                  color: comment.length > 250 ? "red" : "#00000099",
                  display: "flex",
                  justifyContent: "flex-end",
                  fontWeight: 400,
                }}
              >
                {comment.length} / 250
              </Typography> */}
            </Box>
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Typography
                sx={{
                  fontfamily: "Roboto",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "20px",
                  padding:"2px 0px",
                  color: "rgba(0, 0, 0, 0.6)",
                }}
              >
                {t("scheduler_removal-reason-shared-message")}
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions
            sx={{
              padding: "33px 45px",
            }}
          >
            <Box
              sx={{
                display: "flex",
                gap: "12px",
              }}
            >
              <Box>
                <Button onClick={handleClose()}>{t("common_cancel")}</Button>
              </Box>
              <Button
                color="error"
                disabled={disableSave()}
                onClick={ () => handleSubmit(worker)}
                variant="contained"
                startIcon={removeWorkerStatus === "pending" && <CircularProgress size={20} />}
              >
                {removeWorkerStatus === "pending"
                  ? t("scheduler_removing")
                  : t("scheduler_remove-worker")}
              </Button>
            </Box>
          </DialogActions>

        </Dialog>
      )}
    </>
  );
};

export default RemoveShiftWorkerDialog;
